var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandphoneSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.582 17.9725C15.802 19.7515 13.348 20.8505 10.633 20.8505C7.918 20.8505 5.464 19.7515 3.685 17.9725C1.906 16.1925 0.807001 13.7385 0.807001 11.0235C0.807001 8.30847 1.906 5.85447 3.685 4.07547C5.464 2.29647 7.918 1.19747 10.633 1.19747C13.348 1.19747 15.802 2.29647 17.582 4.07547C19.361 5.85447 20.46 8.30847 20.46 11.0235C20.46 13.7385 19.361 16.1925 17.582 17.9725ZM10.633 0.390471C4.761 0.390471 0 5.15147 0 11.0235C0 16.8965 4.761 21.6565 10.633 21.6575C16.506 21.6575 21.266 16.8965 21.266 11.0235C21.266 5.15147 16.506 0.390471 10.633 0.390471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73334 6.67334H6.68668V15.3267H5.73334C5.33 15.3267 5 14.9967 5 14.5933V7.40667C5 7.00334 5.33 6.67334 5.73334 6.67334Z",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 7.40667V14.5933C15.9995 14.9967 15.6695 15.3267 15.2662 15.3267H9.32617V6.67334H15.2662C15.6695 6.67334 15.9995 7.00334 15.9995 7.40667Z",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5371 10.1123V8.13232H11.0904V10.1123H14.5371Z",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32654 6.23333V15.7667C9.32654 16.17 8.99654 16.5 8.5932 16.5H7.41986C7.01653 16.5 6.68652 16.17 6.68652 15.7667V6.23333C6.68652 5.83 7.01653 5.5 7.41986 5.5H8.62987C8.99654 5.5 9.32654 5.83 9.32654 6.23333Z",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0869 11.3667H11.4536",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 11.3667H14.5337",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.627 11.3667H12.9936",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0869 12.6499H11.4536",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 12.6499H14.5337",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.627 12.6499H12.9936",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0869 13.9333H11.4536",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 13.9333H14.5337",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.627 13.9333H12.9936",
    stroke: "white",
    strokeWidth: 0.523811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandphoneSm);
export default __webpack_public_path__ + "static/media/landphone-sm.95bc9abe03b1cde7c8d0f0e11789bafb.svg";
export { ForwardRef as ReactComponent };